import { CONFIG } from 'app/core/config';
import { TemplateAttributeDataType } from '../admin/hierarchy-templates/template-attribute-data-type.enum';
import { ViewModel } from '../view-model';

export class EventTemplateAttribute implements ViewModel {
  public readonly friendlyTypeNameSingular: string = 'Event Template Attribute';
  public readonly apiRoute: string = CONFIG.apiRoutes.eventTemplateAttribute;

  public id: string;
  public name: string;
  public dataType: TemplateAttributeDataType;
  public dataTypeString: string;
  public uomId: string;
  public uomName: string;
  public groupName: string;
  public templateId: string;
  public sourceLookupId: string;
  public processStageId: string;
  public processStageName: string;
  public orderNumber: number;
  public isRequired: boolean;
  public defaultValue: string;

  json() {
    return this;
  }

  loadFromJson(data) {
    this.id = data.id;
    this.name = data.name;
    this.dataType = data.dataType;
    this.dataTypeString = this.dataType ? TemplateAttributeDataType[this.dataType] : '';
    this.uomId = data.uomId;
    this.groupName = data.groupName;
    this.templateId = data.templateId;
    this.sourceLookupId = data.sourceLookupId;
    this.processStageId = data.processStageId;
    this.uomName = data.uomName;
    this.processStageName = data.processStageName;
    this.orderNumber = data.orderNumber;
    this.isRequired = data.isRequired;
    this.defaultValue = data.defaultValue != null ? data.defaultValue : '';
  }
}
